// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueBreadcrumbs from 'vue-breadcrumbs'
import CanvasVideo from 'vue-canvasvideo'
import 'vue-canvasvideo/dist/vuecanvasvideo.min.css'
import MultiLanguage from 'vue-multilanguage'
import languageConf from './assets/languageConf'

Vue.use(MultiLanguage, languageConf)

Object.defineProperty(Vue.prototype, '$bus', {
  get () {
    return this.$root.bus
  }
})
let bus = new Vue({})

Vue.use(VueBreadcrumbs, {
  template: '<nav class="breadcrumbs" v-if="$breadcrumbs.length"> ' +
  '<ul> ' +
  '<li v-for="crumb in $breadcrumbs"> ' +
  '<router-link v-if="crumb.meta.breadcrumbImage" :to="linkProp(crumb)">' +
  '<img v-bind:src="crumb.meta.breadcrumbImage">' +
  '</router-link> ' +
  '<router-link v-else :to="linkProp(crumb)">{{ crumb | crumbText }}</router-link> ' +
  '</li> ' +
  '</ul> ' +
  '</nav>'
})
Vue.use(require('vue-touch/dist/vue-touch'))
Vue.use(CanvasVideo)

Vue.config.productionTip = false

/* eslint-disable no-new */
window.vue = new Vue({
  data: {
    bus
  },
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App }
})

window.language = window.vue.language



// WEBPACK FOOTER //
// ./src/main.js